import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  { label: 'S.N', value: 'id' },
  {
    label: 'Name',
    value: 'certificationName',
  },
  {
    label: 'Number',
    value: 'certificationNo',
  },
  {
    label: 'Issuing authority',
    value: 'issuingAuthorities',
  },
  {
    label: 'Logo',
    value: 'avatar',
  },
  {
    label: 'Issued on',
    value: 'issuedOn',
  },
  {
    label: 'Valid till',
    value: 'validTill',
  },
  {
    action: ['edit', 'delete'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
